define('views/shared/analytics/fb_pixel',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/analytics/fb_pixel.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        isRender : false,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.auto_initialize = options.auto_initialize;

            this.pixel_id = pf.getContent('analytics.pixel.id');
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){

            // if(this.auto_initialize){
                this.initializePixel();
            // }
            
        },

        initializePixel: function(){
            var script_tag = "<script>!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '" + this.pixel_id + "'); fbq('track', 'PageView');</script><noscript><img height=\"1\" width=\"1\" src=\"https://www.facebook.com/tr?id=" + this.pixel_id + "&ev=PageView&noscript=1\"/></noscript>";

            $('html head').append(script_tag);
        },

        subscribe: function(obj_properties){

            if(_.isFunction(fbq)){
                fbq('track', 'Subscribe', obj_properties);
            }
            
        },

        checkout: function(){

            if(_.isFunction(fbq)){
                fbq('track', 'InitiateCheckout');
            }
            
        },

        viewContent: function(){

            if(_.isFunction(fbq)){
                fbq('track', 'ViewContent');
            }
            
        },

        formSubmission: function(){

            if(_.isFunction(fbq)){
                fbq('track', 'SubmitApplication');
            }
            
        },

        close: function(){}
    });
});

